import { createSlice,configureStore } from '@reduxjs/toolkit';

const mobInit ={ viewing: 'false'}

const mobView = createSlice({
    name:'mobile',
    initialState:mobInit,
    reducers:{
        disablewebview(state,action){
        state.viewing = !state.viewing
        }
    }
})


const store = configureStore({
    reducer:{view:mobView.reducer}
})

export const mobActions = mobView.actions

export default store
